import { useEffect } from "react";
import useCustomer from "@/context/customer/useCustomer";
export default function SignupRoute({ children }) {
    const { persistCustomer, validateCustomerData } = useCustomer();
    useEffect(()=>{
        const isUsingMockApi = import.meta.env.VITE_USE_MOCK_API === 'true';
        if (isUsingMockApi) {
            const mockCustomerData = {
                customerIdentifier: 'mock-customer-456',
                customerAWSAccountID: '123456789012',
                productCode: 'mock-product-code'
            };
            const validationResult = validateCustomerData({
                candidateCustomerIdentifier: mockCustomerData.customerIdentifier,
                candidateCustomerAWSAccountID: mockCustomerData.customerAWSAccountID,
                candidateProductCode: mockCustomerData.productCode
            });
            if (validationResult.success) {
                persistCustomer(validationResult.customer);
            }
            return;
        }
        const urlParams = new URLSearchParams(window.location.search);
        const customerIdentifier = urlParams.get('customerIdentifier')?.trim();
        const customerAWSAccountID = urlParams.get('customerAWSAccountID')?.trim();
        const productCode = urlParams.get('productCode')?.trim();
        if (customerIdentifier && customerAWSAccountID && productCode) {
            //validate is just schema parse check
            //do we need to actually validate?
            //this has url pollution, aws account id in url - can leak from browser history or headers
            //problem: network traffic monitoring will still see the info in referrer header.
            //-this can be used for mostly social engineering, guessing s3 buckets
            const validationResult = validateCustomerData({
                candidateCustomerIdentifier: customerIdentifier,
                candidateCustomerAWSAccountID: customerAWSAccountID,
                candidateProductCode: productCode
            });
            if (validationResult.success) {
                persistCustomer(validationResult.customer);
            }
            // Clear URL parameters after processing
            const currentUrl = new URL(window.location.href);
            currentUrl.search = '';
            window.history.replaceState({}, '', currentUrl.toString());
        }
    }, [
        persistCustomer,
        validateCustomerData
    ]);
    return children;
}
